"use client";

import { usePathname, useSearchParams } from "next/navigation";
import { useEffect } from "react";
import { useRef } from "react";
import Script from "next/script";

declare global {
  interface Window {
    dataLayer: unknown[];
    gtag: (...args: unknown[]) => void;
  }
}

const measurementId = process.env.NEXT_PUBLIC_GA_MEASUREMENT_ID;

export default function GoogleAnalytics() {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const isFirstPage = useRef(true);

  useEffect(() => {
    const query = searchParams?.toString();
    const pagePath = `${pathname || "/"}${query ? `?${query}` : ""}`;
    if (!measurementId) return;

    let attempts = 0;
    let timer: number | undefined;
    const sendPageView = () => {
      if (isFirstPage.current) {
        isFirstPage.current = false;
        return;
      }
      if (typeof window.gtag === "function") {
        window.gtag("event", "page_view", {
          page_title: document.title,
          page_location: window.location.href,
          page_path: pagePath,
        });
        return;
      }
      if (attempts < 20) {
        attempts += 1;
        timer = window.setTimeout(sendPageView, 100);
      }
    };
    sendPageView();
    return () => { if (timer) window.clearTimeout(timer); };
  }, [pathname, searchParams]);

  if (!measurementId) return null;

  return (
    <>
      <Script id="google-analytics-init" strategy="afterInteractive">
        {`window.dataLayer = window.dataLayer || []; window.gtag = window.gtag || function(){window.dataLayer.push(arguments);}; window.gtag('js', new Date()); window.gtag('config', '${measurementId}');`}
      </Script>
      <Script id="google-analytics-script" src={`https://www.googletagmanager.com/gtag/js?id=${measurementId}`} strategy="afterInteractive" />
    </>
  );
}